import React from "react";

export const History = () => {
  return (
    <div>
      {" "}
      <h1 className="text-center">History page</h1>
    </div>
  );
};
